<div class="sidebar">
    <lib-search-filter [isMobile]=false></lib-search-filter>
</div>
